import { useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core"
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import { actulizaBancoAction, obtenerBancosAllAction, nuevoBancoAction, targetBancoAction } from "../../../ducks/bancoDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useSelector } from "react-redux";
import { InitialValueBanco } from "../InitialValueBanco";

const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
})

const InitalValues = {
    nombre: "",
}
const ArrayFormValues = [
    {
        name: "nombre",
        type: "text",
        label: "Nombre"
    },
]

const FielEdit = (props) => {
    const {
        name,
        label,
        type = "text",
        formik,
    } = props
    return (
        <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <TextField
                required
                style={{ width: "90%" }}
                id={`id-${name}`}
                label={label}
                type={type}
                variant="outlined"
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                error={formik.touched[name] && Boolean(formik.errors[name])}
                helperText={formik.touched[name] && formik.errors[name]}
            />
        </div>
    )
}

const Form = () => {
    const { editar, banco } = useSelector(store => store.banco)
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    })
    const handleSubmit = (values) => {
        let payload = {
            Nombre: values.nombre,
            TasaCobro: values.tasaCobro,
        }
        dispatch(onLoadAnction({ message: "" }))
        if (editar) {
            payload.idBanco = banco.IdBanco
            payload.Estatus = banco.Estatus
            dispatch(actulizaBancoAction(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerBancosAllAction())
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        } else {
            dispatch(nuevoBancoAction(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerBancosAllAction())
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        }
    }

    useEffect(() => {
        const formLoad = () => {
            formik.setFieldValue("nombre", banco?.Nombre)
        }
        if (editar)
            formLoad()
        else
            formik.resetForm(InitalValues)
    }, [editar, banco.IdBanco]) //eslint-disable-line

    const handleCancel = () => {
        clearForm()
    }
    
    const clearForm = () => {
        formik.resetForm(InitalValues)
        dispatch(targetBancoAction({ banco: InitialValueBanco, editar: false}))
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container>
                <Grid item xs={12}>
                    {
                        <h4>{(editar) ? "Editar Banco" : "Nuevo Banco"}</h4>
                    }
                </Grid>
                {
                    ArrayFormValues.map((item, index) =>
                        <Grid item xs={12} key={item.name}>
                            <FielEdit
                                name={item.name}
                                label={item.label}
                                type={item.type}
                                formik={formik}
                            />
                        </Grid>
                    )
                }
                <Grid item xs={12}>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Guardar
                    </Button>
                    {
                        (editar) &&
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="default"
                            onClick={handleCancel}
                        >
                            Camcelar
                        </Button>
                    }
                </Grid>
            </Grid>
        </form>
    )
}
export default Form